import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      name: "signboards",
      path: "/signboards",
      component: () => import("@/views/Signboards")
    },
    {
      name: "home",
      path: "/",
      component: () => import("@/views/Signboards")
    },
    {
      name: "editor-signboard",
      path: "/edit/signboard/:slug?",
      meta: { requiresAuth: true },
      component: () => import("@/views/SignboardEdit")
    },
    {
      name: "menu",
      path: "/menu/:slug",
      component: () => import("@/views/Menu")
    },
    {
      name: "editor-menu",
      path: "/edit/menu/:slug?",
      meta: { requiresAuth: true },
      component: () => import("@/views/MenuEdit")
    },
    {
      name: "orders",
      path: "/orders/:slug?",
      meta: { requiresAuth: true },
      component: () => import("@/views/OrderList")
    },
    {
      name: "editor-order",
      path: "/edit/order",
      component: () => import("@/views/OrderEdit")
    },
    {
      name: "order-complete",
      path: "/edit/order/:slug?",
      meta: { requiresAuth: true },
      component: () => import("@/views/OrderSetComplete")
    },
    {
      name: "order",
      path: "/order/:slug?",
      component: () => import("@/views/Order")
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/Login")
    },
  ],
})